import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	star: {
		id: 'spa-apps-sidebar-core.common.favorite-button.star',
		defaultMessage: 'Add to Starred',
		description: 'Button label to add a project to favourites.',
	},
	unstar: {
		id: 'spa-apps-sidebar-core.common.favorite-button.unstar',
		defaultMessage: 'Remove from Starred',
		description: 'Button label to remove a project from favourites.',
	},
});
